<style></style>
<template>
  <div class="element-wrapper">
    <div class="element-actions actions-only"></div>
    <h6 class="element-header" style="margin-bottom: 2px">Stock</h6>
    <div class="element-box-tp" style="padding: 0em !important">
      <small>Permitir:</small><br />
      <small
        >C = Compra | V = Venta | A = Ajustes | S = Salida | I = Ingresos | D =
        Devoluciones </small
      >
      <table class="table table-compact smaller mb-0">
        <thead>
          <tr>
            <th>Tienda</th>
            <!--th class="text-center">Date</th-->
            <th class="text-center">Auto</th>
            <th class="text-center">A</th>
            <th class="text-center">C</th>
            <th class="text-center">V</th>
            <th class="text-center">I</th>
            <th class="text-center">S</th>
            <th class="text-center">D</th>           
            <th class="text-right">Min</th>
            <th class="text-right">Max</th>
            <th class="text-right">Reserva</th>
            <th class="text-right">Dispo</th>
            <th class="text-right">Stock</th>            
            <!--th class="text-right"></th-->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="current_stock in tiendasfiltradas"
            v-bind:key="current_stock.id"
          >
            <td>
              <span :class="{'badge badge-danger': !current_stock.activo}">{{ current_stock.tienda}}</span>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.sol_auto == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.sol_auto == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_ajustes == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_ajustes == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_compras == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_compras == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_ventas == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_ventas == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_ingresos_t == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_ingresos_t == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_salidas_t == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_salidas_t == true"
                class="fas fa-square text-success"
              ></i>
            </td>
            <td class="text-center text-bright">
              <i
                v-if="current_stock.permitir_devoluciones == false"
                class="fas fa-square text-danger"
              ></i>
              <i
                v-if="current_stock.permitir_devoluciones == true"
                class="fas fa-square text-success"
              ></i>
            </td>            
            <td class="text-right text-bright">{{ current_stock.minimo }}</td>

            <td class="text-right text-bright">{{ current_stock.maximo }}</td>
            <td class="text-right text-bright">{{ current_stock.existencia_en_reserva }}</td>
            <td class="text-right text-bright">{{ current_stock.existencia_disponible }}</td>
            <td class="text-right">
              <a
                @click="actualizarExistreciasporTienda(current_stock)"
                class="text-right text-success"
                :class="{
                  'text-danger':
                    current_stock.existencia <= current_stock.minimo,
                  'text-warning':
                    current_stock.existencia > current_stock.maximo,
                }"
                >{{ current_stock.existencia }}</a
              >
            </td>
            
            <!--td>
                        <button class="btn btn-sm btn-warning">Editar</button>
            </td-->
          </tr>
        </tbody>
      </table>
      <br />
      <ProductoTiendaModalComponent
        @cerrandomodal="refresh"
        v-if="current.sku != null && filtrartienda == null"
        :current="current"
      />
    </div>
  </div>
</template>

<script>
import ProductoTiendaModalComponent from "@/components/cat/productos/ProductoTiendaModalComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ProductoTiendaModalComponent,
  },
  data() {
    return {
      datos: {
        tiendas: [],
      },
    };
  },
  props: {
    current: {
      type: Object,
      required: true,
    },
    filtrartienda: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tiendasfiltradas() {
      let self = this;
      if (self.current.productotienda_set) {
        return self.current.productotienda_set.filter((t) => {
          return self.filtrartienda == null || t.tienda == self.filtrartienda;
        });
      }
      // console.log("tiendas filtradas", self.tiendasfiltradas);
      return [];
    },
  },
  mounted() {},
  methods: {
    actualizarExistreciasporTienda(current_stock) {
      DynamicService.getAction(
        "cat",
        "productos",
        current_stock.producto,
        "actualizar_existencia_x_tienda",
        {
          tienda_id: current_stock.tienda,
        }
      )
        .then((response) => {
          this.refresh();
        })
        .catch((error) => {
          alert(
            "ERROR, No se actualizo la existencia, consulte al area de sistemas"
          );
        });
    },
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>
